import { render } from "./AsideContent.vue?vue&type=template&id=28cd3e3c&scoped=true"
const script = {}

import "./AsideContent.vue?vue&type=style&index=0&id=28cd3e3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28cd3e3c"]])

export default __exports__